/**
 * @Author: 韩祺涛
 * @Date: 2023-03-17
 * @Project: 杭氧客户现场使用
 */
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 根据资产分类查询字段集合
export function getAssetTypeField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/assetTypeField',
    method: 'GET',
    params: parameter
  })
}
// 保存资产分类所展示字段
export function saveAssetTypeField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/assetTypeField',
    method: 'PUT',
    data: parameter
  })
}
// 获取所有资产字段
export function getAssetField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}